<template>
  <div class="common_bg explain">
    <div class="tel">
      <div class="title">
        <span>注销账号</span>
      </div>
      <div class="content">
        <h2>账号注销风险</h2>
        <h3>无法登陆</h3>
        <p>一旦注销，你将无法使用该账号登陆狸米网校相关服务平台。</p>
        <h3>信息抹除，无法恢复</h3>
        <p>注销后将永久抹除狸米网校的所有信息，包括但不限于课程、金币、徽章、个人资料、消息记录等。</p>
        <p class="num">可在09:00-21:00之间拨打服务热线 <i>010-84997885</i> 进行注销。</p>
      </div>
    </div>
    <Back @goBack="goBack" />
  </div>
</template>
<script>
import Back from "@/components/basic/back.vue";
export default {
  components: {
    Back
  },
  methods: {
    goBack() {
      this.$router.push("/userinfo");
    }
  }
};
</script>
<style lang="less" scoped>
@bg-color: #0089ce;
.explain {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: @bg-color;
    font-size: 26px;
    color: #fff;
    position: relative;
    margin-bottom: 15px;
  }

  .tel {
    width: 100%;
    height: 100%;
    padding-bottom: 60px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .tel .content {
    height: 100%;
    width: 1024px;
    margin: 0 auto;
    border-radius: 20px;
    background: #fff;
    text-align: left;
    padding: 0 45px 30px 45px;
    font-size: 21px;
    color: #333333;
    h2{
      font-size:24px;
      font-weight:600;
      margin-top: 60px;
    }
    h3{
      font-size: 20px;
      font-weight:600;
      margin-top: 45px;
    }
    p {
      margin-top:13px;
      color: #666666;
      font-size: 18px;
    }
    .num {
      margin: 40px 0;
      i{
        font-size: 24px;
        color: @bg-color;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/explain/cancell.vue